import { Injectable } from '@angular/core';
import { HttpService } from './../http-service';

import { Observable } from 'rxjs/Rx'

@Injectable()
export class VeiculoProvider {
  private _url: string = '/veiculos';

  constructor(public http: HttpService) { }

  public getAtivos(): Observable<any> {
    return this.http.get(this._url + '/ativos')
      .map(res => {
        return res.json().data;
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/veiculo/veiculo.provider.ts